import { Marginalia } from './Marginalia';

export function MironBlock({ photoSrc, caption }: { photoSrc?: string; caption: string }) {
  return (
    <figure className="flex flex-col gap-4">
      {photoSrc !== undefined && (
        <img
          src={photoSrc}
          alt="Кот Мирон"
          className="w-full max-w-[320px] rounded-lg shadow-ring-md"
          loading="lazy"
        />
      )}
      <Marginalia>{caption}</Marginalia>
    </figure>
  );
}
